import { rgba, typography } from '../core/utils';

import styled from '@emotion/styled';
import { theme } from '../core/theme';
import { tokens } from '../core/tokens';

export const Modal = {
   Overlay: styled.div`
      position: fixed;
      inset: 0;
      background-color: ${rgba(theme.colors.text.primary, 0.6)};
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: ${tokens.zIndex.modal};
   `,

   Container: styled.div`
      background: ${theme.colors.bg.primary};
      border-radius: ${tokens.radius.lg};
      width: 90%;
      max-width: 800px;
      max-height: 90vh;
      display: flex;
      flex-direction: column;
      box-shadow: ${tokens.shadow.xl};
      border: ${tokens.border.thin} ${theme.colors.border.default};
   `,

   Header: styled.div`
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: ${tokens.space.lg};
      border-bottom: ${tokens.border.thin} ${theme.colors.border.default};
   `,

   Title: styled.h2`
      ${typography.headingL};
      color: ${theme.colors.text.primary};
      margin: 0;
   `,

   Content: styled.div`
      flex: 1;
      overflow-y: auto;
      padding: ${tokens.space.xxl};
   `,

   Footer: styled.div`
      display: flex;
      justify-content: flex-end;
      gap: ${tokens.space.md};
      padding: ${tokens.space.md};
      border-top: ${tokens.border.thin} ${theme.colors.border.default};
   `,
};

export const ModalCloseButton = styled.div`
   position: absolute;
   top: 3rem;
   right: 3rem;
`;
